<template>
    <el-container>
        <el-aside :width="sidebarDetail.sidebarWidth" class="menu-side-bar">
            <navbar :sidebar-detail="sidebarDetail"></navbar>
        </el-aside>
        <el-main :style="{'padding': defaultPadding ? '20px' : 'unset'}">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </el-main>
    </el-container>
</template>

<script>
import Navbar from '@/components/layout/Navbar.vue'
import { eventBus } from '@/main'

export default {
    name: 'FinanceMain',
    components: {
        Navbar
    },
    data () {
        return {
            sidebarDetail: {
                sidebarWidth: '64px'
            },
            defaultPadding: true
        }
    },
    created () {
        eventBus.$on('setDefaultPadding', (flag) => {
            this.defaultPadding = flag
        })
    }
}
</script>

<style lang="scss">
.menu-side-bar {
    // background-color: black;
    padding: 0 0px !important;
}
</style>
